import React, { useState } from "react";
import { Lock } from "lucide-react";
import SubscribeDialog from "@/components/SubscribeDialog";

/**
 * Wraps premium-only content. When `locked` is true, renders an
 * overlay with a lock + unlock CTA on top of a blurred preview.
 */
export default function LockedOverlay({ locked, children, testId, label = "Función Premium" }) {
  const [openSub, setOpenSub] = useState(false);

  if (!locked) return <>{children}</>;

  return (
    <>
      <div className="relative" data-testid={testId}>
        <div className="pointer-events-none select-none filter blur-[6px] opacity-60">
          {children}
        </div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          <div className="w-12 h-12 rounded-full bg-white shadow-md flex items-center justify-center mb-2 ring-1 ring-[#E2E8F0]">
            <Lock className="w-5 h-5 text-[#0052FF]" />
          </div>
          <p className="text-xs uppercase tracking-[0.2em] text-[#94A3B8] font-medium mb-1">
            {label}
          </p>
          <button
            onClick={() => setOpenSub(true)}
            className="bg-[#0052FF] hover:bg-[#0040CC] text-white text-xs font-semibold px-4 py-2 rounded-lg transition-colors"
            data-testid={`${testId}-unlock-btn`}
          >
            Desbloquear
          </button>
        </div>
      </div>

      <SubscribeDialog open={openSub} onOpenChange={setOpenSub} />
    </>
  );
}
